/*
 * @Author: Dom
 * @Date: 2022-07-20 14:51:48
 * @LastEditTime: 2022-07-21 17:27:46
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\contract\service.ts
 */
import request from '@/utils/request'
import {TableParamsType} from './data.d'

export async function userContractList(params:TableParamsType): Promise<any>{
    return request({
        url: '/seller/v1/user/userContractList',
        method: 'POST',
        data: params
    })
}
